<p>delete-account works!</p>
